import React, { useEffect } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import OemListing from "./OemListing";

const Oem = () => {
  const breadcrumbItems = [
    { title: "OEM", link: "" },
    { title: "OEM", link: "/prod/oem" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
            <OemListing/>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Oem;